/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { documentService } from '../../../../api/services/documentService';
import {
  setEmployeeExpiredDocs,
  setEmployeeExpiredDocsLoader,
  setExpiredDocsRefreshData,
} from '../../../../infra/aggregates/myProfile/DocumentAggregates/getExpiredEmpDocsSlice';

interface PropsValues {
  setDocumentsData: (data: any) => void;
}
function DTOExpiredDocs({ setDocumentsData }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const all_Docs = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.empExpDocsData,
  );

  const refreshData = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.expiredDocRefreshData,
  );

  const dispatch = useAppDispatch();
  async function getEmployeeDocuments(companyId: number, empId: number) {
    dispatch(setEmployeeExpiredDocsLoader(true));
    const response: any = await documentService.getExpiredDocs(
      companyId,
      empId,
    );

    if (response.response == 'success') {
      const empExpDocsData: any = response?.data;

      dispatch(setEmployeeExpiredDocs(empExpDocsData));
      /* Passing Props to Controller */

      setDocumentsData(empExpDocsData);
      dispatch(setEmployeeExpiredDocsLoader(false));
    } else {
      dispatch(setEmployeeExpiredDocsLoader(false));
      return;
    }
  }
  useEffect(() => {
    getEmployeeDocuments(selector.company_id, selector.emp_id);
  }, []);

  useEffect(() => {
    if (refreshData) {
      getEmployeeDocuments(selector.company_id, selector.emp_id);
      dispatch(setExpiredDocsRefreshData(false));
    }
  }, [refreshData]);

  useEffect(() => {
    setDocumentsData(all_Docs);
  }, [all_Docs]);

  return <></>;
}
export default DTOExpiredDocs;
